const translations = {
    deleteError: 'Error deleting flight logs. Please try again later.',
    noFlights: 'No flight logs were found with these filters',
    title: 'Flights & Maps',
    uploadFlightLog: 'Upload Flight Log'
};

export default translations;
